import React from 'react';
import Footer from '../components/footer';
import styled, { createGlobalStyle } from 'styled-components';

// Assets
import car from '../../assets/Sylver.mp4';
import wild from '../../assets/wild.mp4';
import legendary from '../../assets/legendary.mp4';
import awakened from '../../assets/awakening.mp4';
import sacred from '../../assets/SacredLotus.mp4';
import petals from '../../assets/lightenedpetals.mp4';
import logo from '../../assets/logo.png';
import poops from '../../assets/poopy.png';
import vidiLo from '../../assets/rekt.mp4';
import lotuslogo from '../../assets/lotuslogo.png';
import crap from '../../assets/crapmp.mp4';
import mezcal from '../../assets/originalbacanora.jpg';
import churros from '../../assets/discordChurro.png';
import t from '../../assets/t.png';
import Poster from '../../assets/sylverposter.png';
import poopss from '../../assets/poops.png';
import shoreline from '../../assets/shoreline.jpg';
import pangoline from '../../assets/pangolin.jpg';
import Header from '../menu/header2';
// Global styles for hover effects and media behavior
const GlobalStyle = createGlobalStyle`
  .hover-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 10px;
  }

  .hover-container img,
  .hover-container video {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensures media fills the container without distortion */
    transition: opacity 0.3s ease;
  }

  .hover-container:hover img,
  .hover-container:hover video {
    opacity: 0.5;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2em;
    font-weight: bold;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .hover-container:hover .overlay {
    opacity: 0.88;
  }
`;

// Use CSS Grid to display three cards per row on larger screens and one per row on mobile.
// The grid-template-columns is set to three auto-sized columns (each will contain a FixedCard of 20em width)
// On screens under 768px, we force a single-column layout.
const CardContainer = styled.div`
  display: grid;
  gap: 1em;
  justify-items: center;
  grid-template-columns: repeat(3, auto);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// FixedCard forces a fixed width and a fixed aspect ratio.
// Using flex-shrink: 0 ensures it never shrinks in a flex container.
const FixedCard = styled.div`
  flex: 0 0 auto;
  width: 20em;     
  aspect-ratio: ${props => props.aspect || '1 / 1'};
`;

export default function Works() {
  return (
    <div style={{ paddingTop: '10em', backgroundColor: 'black' }}>
      <Header/>
      <GlobalStyle />
      
      {/* CardContainer now uses CSS Grid to show three cards per row (desktop) and one per row (mobile) */}
      <CardContainer>
        {/* Card 1 */}
        <FixedCard>
          <div className="hover-container">
            <img src={Poster} alt="Metaverse Poster" />
            <div className="overlay">Metaverse Poster</div>
          </div>
        </FixedCard>

        {/* Card 2 */}
        <FixedCard>
          <div className="hover-container">
            <img src={mezcal} alt="Mezcal" />
            <div className="overlay">Mezcal</div>
          </div>
        </FixedCard>

        {/* Card 3 */}
        <FixedCard>
          <div className="hover-container">
            <img src={churros} alt="Churritos Metaverse Collection" />
            <div className="overlay">Churritos Metaverse Collection</div>
          </div>
        </FixedCard>

        {/* Card 4 */}
        <FixedCard>
          <div className="hover-container">
            <img src={poopss} alt="Poopyheads Collection" />
            <div className="overlay">Poopyheads Collection</div>
          </div>
        </FixedCard>

        {/* Card 5 */}
        <FixedCard>
          <div className="hover-container">
            <img src={t} alt="Natural Coffee Maker" />
            <div className="overlay">Natural Coffee Maker</div>
          </div>
        </FixedCard>

        {/* Card 6 */}
        <FixedCard>
          <div className="hover-container">
            <img src={pangoline} alt="Pangolin Natural Car Care" />
            <div className="overlay">Pangolin Natural Car Care</div>
          </div>
        </FixedCard>

        {/* Video Card 7 */}
        <FixedCard>
          <div className="hover-container">
            <video src={car} controls loop />
          </div>
        </FixedCard>

        {/* Video Card 8 */}
        <FixedCard>
          <div className="hover-container">
            <video src={wild} controls loop />
          </div>
        </FixedCard>

        {/* Video Card 9 */}
        <FixedCard>
          <div className="hover-container">
            <video src={legendary} controls loop />
          </div>
        </FixedCard>

        {/* Video Card 10 */}
        <FixedCard>
          <div className="hover-container">
            <video src={awakened} controls loop />
          </div>
        </FixedCard>

        {/* Video Card 11 */}
        <FixedCard>
          <div className="hover-container">
            <video src={sacred} controls loop />
          </div>
        </FixedCard>

        {/* Video Card 12 */}
        <FixedCard>
          <div className="hover-container">
            <video src={petals} controls loop />
          </div>
        </FixedCard>

        {/* Video Card 13 */}
        <FixedCard>
          <div className="hover-container">
            <video src={vidiLo} controls loop />
          </div>
        </FixedCard>

        {/* Video Card 14 */}
        <FixedCard>
          <div className="hover-container">
            <video src={crap} controls loop />
          </div>
        </FixedCard>

        {/* Cards with a different aspect ratio (20em x 15em) */}
        <FixedCard aspect="20 / 15">
          <div className="hover-container">
            <img src={logo} alt="Poopyheads Branding" />
            <div className="overlay">Poopyheads Branding</div>
          </div>
        </FixedCard>

        <FixedCard aspect="20 / 15">
          <div className="hover-container">
            <img src={poops} alt="Poopyheads Promotional" />
            <div className="overlay">Poopyheads Promotional</div>
          </div>
        </FixedCard>

        <FixedCard aspect="20 / 15">
          <div className="hover-container">
            <img src={lotuslogo} alt="Lotus Farm Branding" />
            <div className="overlay">Lotus Farm Branding</div>
          </div>
        </FixedCard>

        <FixedCard aspect="20 / 15">
          <div className="hover-container">
            <img src={shoreline} alt="Shoreline International Partners Branding" />
            <div className="overlay">Shoreline International Partners Branding</div>
          </div>
        </FixedCard>
      </CardContainer>
      <Footer />
    </div>
  );
}
